<template>
    <!-- 商圈資訊和活動頁的店家列表 -->
    <div class="brandList">
        <div class="mb-5">

            <category-header title="在地精選" class="mb-2" v-show="shopStoreList.length > 0"/>
            <!--資訊頁-智慧雲的店家用這種格式-->
            <article-cover :list="shopStoreList" :showRemark="isShowRemark" :remark="getRemark" :shopType="'store'" hideStar/>

            <category-header title="品牌好店" class="mb-2" v-show="shopVendorList.length > 0"/>
            <!--活動頁-攤販用這種格式-->
            <article-cover :list="shopVendorList" :showRemark="isShowRemark" :remark="getRemark" marketplaceActivity hideStar>
                <!-- 取用子元件傳出的 item屬性 -->
                <template class="shop-item article-cover intro-con" v-slot:default="{item}">

                    <div class="icons">
                        <div class="stall-num" v-if="isShowStallCode(item)">
                            <img src="../../../assets/images/stall.svg">
                            <span>{{item.stallCode}}</span>
                        </div>
                        <el-button
                            type="text"
                            class="store-phone-btn"
                            v-show="isShowPhone(item)"
                            @click="$public.callTel(item.tel)"/>

                        <!--todo 攤販才有照片功能-->
                        <!--<el-button
                                type="text"
                                class="store-photo-btn" @click="openPhoto(item.photoImageUrlAry)"/>-->

                    </div>
                </template>
            </article-cover>
        </div>

        <infinite-loading @infinite="setupDataScroll" :identifier="infiniteInfinite" ref="infiniteLoading" spinner="waveDots" v-if="setupListData">
            <div slot="no-more">已沒有更多資料</div>
            <span slot="no-results">已沒有更多資料</span>
        </infinite-loading>
        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>

        <el-dialog
                :append-to-body="true"
                :modal-append-to-body="false"
                class="stall-photo-pop"
                @close="closePhoto"
                :visible.sync="stallImgDialog">
            <banner :list="stallImgAry" :store="Number(1)"/>
        </el-dialog>
        <toast/>
    </div>
</template>

<script>
    import CategoryHeader from '@/components/category/Header'
    import ArticleCover from '@/components/article/ArticleCover'
    import Banner from './StallPhotoSlider';

    import * as mutationTypes from '@/store/mutationTypes'
    import Toast from "@/components/Toast";
    export default {
        name: "Brand",
        components: {
            CategoryHeader,
            ArticleCover,
            Toast,
            Banner,
        },
        data() {
            return {
                //分類標題
                shopAreaId: Number(this.$store.state.shopAreaInfo.id),   //商圈 id
                shopActivityId: Number(this.$route.query.shopActivityId),   //活動 id
                isLoading: false,
                //攤販照片彈窗
                stallImgDialog: false,
                stallImgAry: [
                    {
                        imgUrl: require('@/assets/images/test2.jpg'),
                    },
                    {
                        imgUrl: require('@/assets/images/test1.jpg'),
                    }
                ],

                shopStoreList : [],         //商店列表
                shopVendorList: [],         //攤販列表

                //加載資料與恢復頁面狀態相關
                setupListData: false,       //是否有載入過初始資料?
                infiniteInfinite: 0,
                infiniteLoadingState: '',
                scrollTo: '',
                offsetHeight: 0,
            }
        },
        created() {
        },
        mounted() {

            this.setupData();
        },
        methods: {

            /** 是否爲活動用？ */
            isActivity: function () {
                return isNaN(this.shopActivityId);
            },

            /** 初始設定 */
            setupData: function () {

                let self = this;

                // 切換tab後先暫停套件，等gps定位完成後再繼續載入，避免載入相同的資料
                if (this.infiniteLoadingState !== '') {
                    this.infiniteLoadingState.complete();
                }

                //取得 GPS
                self.getGpsLocation()
                    .then(
                        () => {
                            if (self.isActivity()) {
                                return self.getShoppingAreaStoreList().then(() => {
                                    self.$emit('checkShopStoreList', self.shopStoreList);
                                })
                            } else {
                                return self.getShoppingAreaStoreList().then(() => {
                                    self.$emit('checkShopStoreList', self.shopStoreList);
                                })
                            }
                        }
                    )
                    .then(
                        self.getShoppingAreaVendorList
                    )
                    .then(
                        () => {

                        }
                    )
                    .catch((error) => {
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },

            /** 資料開始載入 */
            startLoading() {
                let self = this;
                self.isLoading = false;
                setTimeout(function(){
                    // console.log(`startLoading infiniteLoadingState`);
                    if (!self.setupListData) {
                        self.setupListData = true;
                        if (self.infiniteLoadingState !==  '') {
                            self.infiniteLoadingState?.reset();
                        }
                    }

                    //改變 infiniteInfinite，才能讓 infinite-loading觸發載入事件
                    self.infiniteInfinite += 1;
                },100)
            },

            /** 下拉載入更多 */
            setupDataScroll: function ($state) {
                let self = this;
                self.infiniteLoadingState = $state
                self.isLoading = true;

                self.getShoppingAreaStoreList($state)
                    .then( () => {
                        self.isLoading = false;
                    })
                    .catch( (error) => {
                        self.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },

            /** 取得GPS位置 */
            getGpsLocation: function () {

                let self = this;
                return new Promise(function(resolve, reject) {
                    let onSuccess = function (position) {
                        self.lng = position.coords.longitude;
                        self.lat = position.coords.latitude;
                        //完畢
                        resolve();
                    };

                    let onError = function (error) {
                        // reject("無法定位GPS");
                        //完畢
                        resolve();
                    };

                    self.$public.getGpsLocation(onSuccess, onError);
                });
            },

            /** 取得商圈商店列表 */
            getShoppingAreaStoreList: function ($state) {
                // let pData = this.pageData;
                let self = this;
                self.infiniteLoadingState = $state;

                return new Promise(function(resolve, reject) {
                    if (self.shopAreaId !== undefined && self.shopAreaId > 0) {
                        //夜市商圈列表
                        self.$http.fetch`GetShoppingAreaStoreList${{
                            shopAreaId: self.shopAreaId,
                            lng: self.lng,
                            lat: self.lat,
                        }} ${json => {

                            if (self.$public.notNull(json.data)) {
                                self.currentPage++;

                                //把商圈商店資料轉成一般商店資料
                                let newList = self.transShopStoreList(json.data);

                                self.shopStoreList.tmz_load_push(...newList);
                                if (json.data.length >= self.pageSize) {
                                    self.infiniteLoadingState?.loaded();

                                } else {
                                    self.infiniteLoadingState?.complete();
                                }

                                //完成
                                resolve();

                            } else {
                                //失敗
                                self.infiniteLoadingState?.complete();
                                reject('失敗');
                            }
                        }}`;
                    }
                });
            },

            /** 取得商圈攤販列表 */
            getShoppingAreaVendorList: function ($state) {
                // let pData = this.pageData;
                let self = this;
                self.infiniteLoadingState = $state;

                return new Promise(function(resolve, reject) {
                    if (self.shopAreaId !== undefined && self.shopAreaId > 0) {
                        //夜市商圈列表
                        self.$http.fetch`GetShoppingAreaVendorList${{
                            shopAreaId: self.shopAreaId,
                        }} ${json => {

                            if (self.$public.notNull(json.data)) {
                                self.currentPage++;

                                //把商圈商店資料轉成一般商店資料
                                let newList = self.transShopVendorList(json.data);

                                self.shopVendorList.tmz_load_push(...newList);
                                if (json.data.length >= self.pageSize) {
                                    self.infiniteLoadingState?.loaded();

                                } else {
                                    self.infiniteLoadingState?.complete();
                                }

                                //完成
                                resolve();

                            } else {
                                //失敗
                                self.infiniteLoadingState?.complete();
                                reject('失敗');
                            }
                        }}`;
                    }
                });
            },

            /** 將商圈商店轉成一般商店資料結構 */
            transShopStoreList: function(shopStoreList) {
                let self = this;
                let result = [];
                if (this.$public.notNull(shopStoreList)) {
                    shopStoreList.forEach(function (value) {
                        if (self.$public.notNull(value)) {
                            result.push( self.transShopStoreToStore(value)) ;
                        }
                    })
                }
                return result;
            },

            /** 將商圈商店轉成一般商店資料結構 */
            transShopStoreToStore: function(shopStore) {
                if (this.$public.notNull(shopStore)) {
                    let storeStruct = {
                        address: '',
                        appListId: '',
                        brandName: shopStore.brandName,
                        businessHours: [],
                        city: shopStore.city,
                        couponLogoImageList: [],
                        description: '',
                        distance: shopStore.distance,
                        frontUrl: shopStore.coverImageUrl,   //封面
                        id: shopStore.storeId,                  //商店ID，商店專用，所以非商店者此欄位爲 0
                        imgLogoUrl: shopStore.logoImageUrl,         //
                        imgUrl: '',         //
                        lat: 0,
                        lng: 0,
                        name: shopStore.storeName,
                        noteIcon: shopStore.noteIcon,
                        notes: shopStore.notes,
                        noteStatus: shopStore.noteStatus,
                        priceRange: shopStore.priceRange,
                        priceStatus: shopStore.priceStatus,
                        showBusiness: false,
                        star: shopStore.star,
                        tel: shopStore.phone,
                        title: shopStore.title,
                        township: shopStore.township,

                        //新增
                        merchantType: shopStore.merchantType,
                        stallCode: shopStore.stallCode,
                        brandId: shopStore.brandId,
                        storeId: shopStore.storeId,
                        vendorId: 0,
                        photoImageUrlAry: undefined,
                    }
                    return storeStruct;
                }
                return {};
            },

            /** 將商圈攤位轉成一般商店資料結構 */
            transShopVendorList: function(shopVendorList) {
                let self = this;
                let result = [];
                if (this.$public.notNull(shopVendorList)) {
                    shopVendorList.forEach(function (value) {
                        if (self.$public.notNull(value)) {
                            result.push( self.transShopVendorToStore(value)) ;
                        }
                    })
                }
                return result;
            },

            /** 將商圈攤位轉成一般商店資料結構 */
            transShopVendorToStore: function(shopVendor) {
                if (this.$public.notNull(shopVendor)) {
                    let storeStruct = {
                        address: '',
                        appListId: '',
                        brandName: shopVendor.vendorName,
                        businessHours: [],
                        city: '',
                        couponLogoImageList: [],
                        description: '',
                        distance: '',
                        frontUrl: shopVendor.coverImageUrl,   //封面
                        id: 0,                                  //商店ID，商店專用，所以非商店者此欄位爲 0
                        imgLogoUrl: shopVendor.logoImageUrl,         //
                        imgUrl: '',         //
                        lat: 0,
                        lng: 0,
                        name: '',
                        noteIcon: '',
                        notes: shopVendor.notes,
                        noteStatus: false,
                        priceRange: '',
                        priceStatus: false,
                        showBusiness: false,
                        star: '',
                        tel: shopVendor.phone,
                        title: shopVendor.title,
                        township: '',

                        //新增
                        merchantType: shopVendor.merchantType,
                        stallCode: shopVendor.stallCode,
                        brandId: 0,
                        storeId: 0,
                        vendorId: shopVendor.vendorId,
                        photoImageUrlAry: shopVendor.photoImageUrlAry,
                    }
                    return storeStruct;
                }
                return {};
            },

            /** 取得顯示用店名 */
            getShowName: function(shopAreaStore) {
                if (this.$public.notNull(shopAreaStore)) {
                    return `${shopAreaStore.brandName}${shopAreaStore.storeName}`
                }
                return '';
            },

            /** 是否顯示攤位號碼 */
            isShowStallCode: function(storeInfo) {
                return (this.$public.notNull(storeInfo.stallCode) &&
                            storeInfo.stallCode !== '') ;
            },

            /** 是否顯示電話 */
            isShowPhone: function(storeInfo) {
                return (this.$public.notNull(storeInfo.tel) &&
                    storeInfo.tel !== '') ;
            },

            /** 是否顯示備註 */
            isShowRemark: function(storeInfo) {
                return ( this.$public.notNull(storeInfo.title) && storeInfo.title !== '') &&
                        (this.$public.notNull(storeInfo.notes) && storeInfo.notes.length > 0) &&
                        (this.$public.notNull(storeInfo.noteStatus) && storeInfo.noteStatus);
            },

            /** 備註 */
            getRemark: function(storeInfo) {
                let result = '';
                if (storeInfo.notes !== undefined &&
                    storeInfo.notes !== null &&
                    storeInfo.notes.length > 0) {
                    storeInfo.notes.forEach(function (value) {
                        if (value !== '') {
                            result = result + '<p>'+ value ;
                        }
                    })
                }
                return result;
            },

            /** 攤位輪播圖轉換，傳入攤位的輪播圖陣列，傳出輪播圖元件可以用的新陣列 */
            getGalleryAry: function(imgAry){
                let self = this;
                let result = [];
                if (this.$public.notNull(imgAry)) {
                    imgAry.forEach(function (value) {
                        if (self.$public.notNull(value.path)) {
                            let newObj = {
                                imgUrl: value.path,
                            }
                            result.push(newObj) ;
                        }
                    })
                }
                return result;
            },

            //開啟攤販輪播圖
            openPhoto(imgAry){

                this.stallImgAry = this.getGalleryAry(imgAry);

                this.stallImgDialog = true
                //彈窗要改黑色背景
                document.body.classList.add('bg-dark')
            },

            //關閉攤販輪播圖
            closePhoto(){
                //彈窗要改回預設
                document.body.classList.remove('bg-dark')
            }
        }
    }
</script>
